import React from "react";
import Tooltip from "@mui/material/Tooltip";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import useResponsive from "../../../hooks/useResponsive";
import { useSelector } from "react-redux";

export interface CardsProps {
  title: string;
  value: number | string;
  isCurrency : boolean;
  tooltip: string;
  onClick?: () => void;
  isSelected?: boolean;
  clickable?: boolean;
  index?: number;
}

const Cards: React.FC<CardsProps> = ({
  title,
  value,
  tooltip,
  onClick,
  isCurrency = false,
  isSelected = false,
  clickable = false,
}) => {
  const icon = useSelector((state: any) => state.sessionData.sessionScope.currencySymbol || "");
  
  // const sessionBranchId = sessionList?.branchId || 23508;  
const match = icon.match(/fa-[\w-]+/);
const iconName = match ? match[0] : "fa-inr";
  const isMobile = useResponsive();
  return (
    <Tooltip 
    title={tooltip} 
    disableFocusListener
    disableTouchListener
    >
      <Card
        onClick={onClick}
        sx={{
          minWidth: 146,
          padding: "3px 10px",
          border:
            isSelected && tooltip
              ? "1px solid #00a4e5"
              : "1px solid transparent",
          boxShadow: "none",
          backgroundColor: "#D9E4EC",
          cursor: clickable ? "pointer" : "",
        }}
      >
        
        <CardContent
          style={{
            textAlign: "center",
            color: "#00a4e5",
            padding: "1px",
            overflow: isMobile ? "Hidden" : "",
          }}
        >
          <Typography
            variant="h5"
            component="div"
            style={{
              fontSize: "25px",
              fontWeight: "600",
              lineHeight: "40px",
              fontFamily: '"Plus Jakarta Sans", sans-serif',
            }}
          >
           {isCurrency && <i className={`fa ${iconName} currency_style`} style={{ fontSize: '1.8rem' }}></i>} {value}
          </Typography>
          <Typography
            color="text.secondary"
            style={{
              fontSize: "15px",
              fontWeight: "500",
              lineHeight: "18px",
              paddingBottom : "0",
              color: "#000",
              fontFamily: '"Plus Jakarta Sans", sans-serif',
            }}
          >
            {title}
          </Typography>
        </CardContent>
      </Card>
    </Tooltip>
  );
};

export default Cards;
